const appLauncher = {
  allApps: "Все приложения",
  entities: "Записи",
  history: "История",
  records: "Записи",
  noRecords: "Нет записей",
  noHistory: "Нет истории",
  openApp: "Открыть {appName}",
  justNow: "сейчас",
  minutesAgo: "{minutes} мин назад",
  hoursAgo: "{hours} ч назад",
  daysAgo: "{days} дн назад",
} as const;

export default appLauncher;